import { ga } from '../../engine/ga-sidecar'
import { websockets } from '../../engine/websockets-sidecar'
import { l } from '../../lib/imports'
import { chessAiRando } from './ai/chessAiRando-sidecar'
import { chessBackground } from './chessBackground-sidecar'
import { chessGameManager } from './chessGameManager-sidecar'
import { chessGameMode_game_handicap } from './chessGameMode_game_handicap-sidecar'
import { chessGameMode_game_layout } from './chessGameMode_game_layout-sidecar'
import { chessGameRules } from './chessGameRules-sidecar'
import { chessPicker } from './chessPicker-sidecar'
import { EChessTeam } from './chessPieces'
import { chessPieces } from './chessPieces-sidecar'
import { EChessPieceType } from './chessPiecesData'
import { EChessHostCommand } from './messages/chessMessageHostCommand'
import { chessMessageHostCommand } from './messages/chessMessageHostCommand-sidecar'
import { chessWebsockets } from './messages/chessWebsockets-sidecar'
import { chessSounds } from './sound/chessSounds-sidecar'
import { chessUiGame } from './ui/chessUiGame-sidecar'
import { chessUiMenuMain } from './ui/chessUiMenuMain-sidecar'

const namespace = 'chess-game'

let _signalNewGame = true
export function signalReset() {
  console.log('!! GAME RESET')
  chessPieces.killAll()
  chessPicker.clearSelection()

  chessBackground.switchImage()

  if (!websockets.getIsSingleplayer()) {
    chessAiRando.killAll()
  }

  _signalNewGame = true
  _gameStarted = false
  _gameEnded = false
}
let _gameStarted = false
let _gameEnded = false
export function signalGameStarted() {
  _gameStarted = true
  _playedEndgameSound = false
}
export function getIsGameStarted() {
  return _gameStarted
}
export function getIsGameEnded() {
  return _gameEnded
}
let _playedEndgameSound = false

function playEndgameSound(won: EChessTeam) {
  _gameEnded = true
  if (!_playedEndgameSound) {
    if (chessGameManager.get().team === won) {
      chessSounds.playVictory()
    } else if (chessGameManager.get().team === EChessTeam.Spectator) {
      chessSounds.playGameDoneSpectator()
    } else {
      chessSounds.playLoss()
    }
    _playedEndgameSound = true
  }

  if (won === EChessTeam.White) {
    chessMessageHostCommand.sendText('White Wins!')
    if (websockets.getIsHost()) {
      ga.action('event', 'victory-white')
    }
  }
  if (won === EChessTeam.Black) {
    chessMessageHostCommand.sendText('Black Wins!')
    if (websockets.getIsHost()) {
      ga.action('event', 'victory-black')
    }
  }
}

export function* generator_game(): Generator<number, number, number> {
  console.log(namespace, 'starting game!!')

  chessUiMenuMain.setOpen(false)
  chessUiGame.setOpen(true)

  if (websockets.getIsHost()) {
    chessGameRules.setNormal()
  }

  if (chessWebsockets.getIsSingleplayer()) {
    chessMessageHostCommand.sendMessageAndImmediatelyExecute({
      command: EChessHostCommand.Reset,
    })
  }

  chessMessageHostCommand.sendText('')

  chessGameManager.resetHandicap()

  while (true) {
    chessMessageHostCommand.sendText('Layout')

    yield* chessGameMode_game_layout.generator_layoutBoard()

    chessMessageHostCommand.sendText('Handicap')

    yield* chessGameMode_game_handicap.generator_handicap()
    _signalNewGame = false

    chessMessageHostCommand.sendText('')

    if (chessWebsockets.getIsHost()) {
      chessMessageHostCommand.sendMessageAndImmediatelyExecute({
        command: EChessHostCommand.GameStart,
      })
    }

    while (true) {
      // if (!_gameStarted) {
      //   yield 0
      //   continue
      // }

      let hasWhite = false
      let hasBlack = false
      l.forEach(chessPieces.getAll(), (c) => {
        if (c.type === EChessPieceType.King) {
          if (c.team === EChessTeam.White) {
            hasWhite = true
          }
          if (c.team === EChessTeam.Black) {
            hasBlack = true
          }
        }
      })

      // TODO victory for one player
      if (_gameStarted) {
        if (hasWhite && !hasBlack) {
          playEndgameSound(EChessTeam.White)
        } else if (!hasWhite && hasBlack) {
          playEndgameSound(EChessTeam.Black)
        }
      }

      if (chessWebsockets.getIsHost()) {
        if (!_signalNewGame) {
          if (!hasWhite || !hasBlack) {
            yield 2

            if (hasWhite && !hasBlack) {
              chessGameManager.addHandicap(3)
            } else if (!hasWhite && hasBlack) {
              chessGameManager.addHandicap(-3)
            }

            chessMessageHostCommand.sendMessageAndImmediatelyExecute({
              command: EChessHostCommand.Reset,
            })
            // _signalNewGame = true
          }
        }
      }

      if (_signalNewGame) {
        break
      }

      yield 0
    }

    yield 0
  }

  return 0
}
